<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="650"
      max-height="90%"
      min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t("sites.landing_page") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin" :loading="savingInProgress">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="lp_form">
        <v-text-field

            v-model="tmpSite.target_url"
            :prefix="tmpSite.protocol + tmpSite.domain"
            :rules="[(v) => !!v || $t('form.validationErrors.field_is_required'),
            (v)=>v.indexOf('*part_number*') !== -1 || $t('form.validationErrors.field_must_be_contain', ['*part_number*'])
            ]"
        ></v-text-field>
        </v-form>
        <p class="text-body-1">
          <kbd>*part_number*</kbd> {{$t("sites.landing_page_part_number_definition")}}
        </p>
        <p class="text-body-1"><kbd>*brand*</kbd>
          {{$t("sites.landing_page_brand_definition")}}
        </p>

        <v-card
            class="mx-auto"
        >

          <v-card-title>
            {{$t("common.example")}} 1
          </v-card-title>

          <v-card-subtitle class="pb-0">
            http://mysait.com/parts/<kbd>*brand*</kbd>/<kbd>*part_number*</kbd>/
            <p>{{$t("sites.landing_page_example")}}</p>
          </v-card-subtitle>
          <v-card-subtitle class="pt-0">
           http://mysait.com/parts/<kbd>bremi</kbd>/<kbd>12345</kbd>/
            <p>{{$t("sites.landing_page_example_bremi_12345")}}</p>
          </v-card-subtitle>
        </v-card>
        <v-card
            class="mx-auto mt-3"
        >

          <v-card-title>
            {{$t("common.example")}} 2
          </v-card-title>

          <v-card-subtitle class="pb-0">
            http://mysait.com/?pbrandnumber=<kbd>*part_number*</kbd>&pbrandname=<kbd>*brand*</kbd>
            <p>{{$t("sites.landing_page_example")}}</p>
          </v-card-subtitle>
          <v-card-subtitle class="pt-0">
            http://mysait.com/?pbrandnumber=<kbd>12345</kbd>&pbrandname=<kbd>bremi</kbd>
            <p>{{$t("sites.landing_page_example_bremi_12345")}}</p>
          </v-card-subtitle>
        </v-card>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin" small :loading="savingInProgress">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn small
            class="white--text"
            elevation="0"
            color="success"
            @click="save"
            :loading="savingInProgress"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
  name: "LandingPageWindow",
  props: {
    site: null,
    savingInProgress: false,
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    foo: "bar",
    tmpSite:{}
  }),
  computed:{
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods:{
    save(){
      if (this.$refs['lp_form'].validate()) {
        this.$emit('save', this.tmpSite)
      }
    },
    hideWin() {
      this.isVisibleWindow = false;
    },
  },
  watch:{
    isVisibleWindow(to){
      if(to){
        this.tmpSite = {...this.site}
      }
    }
  }
}
</script>

<style scoped>

</style>